import { AlertType } from '@aloft/toolkit-shared';

import {
  setFocusedAlertType,
  setMobileReferenceMenuOpen,
  setReferenceViewOpen,
  setSelectedDataSheet,
} from '../redux/features/referenceBarUISlice.ts';
import { store } from '../redux/store.ts';

export const openAlerts = (focusedAlertType?: AlertType) => {
  store.dispatch(setSelectedDataSheet('craftsman-alerts'));
  store.dispatch(setReferenceViewOpen(true));
  store.dispatch(setMobileReferenceMenuOpen(false));
  store.dispatch(setFocusedAlertType(focusedAlertType ?? null));
};
